import $ from 'jquery';


var w = $(window).width();
var x = 768;
if (w <= x) {
	$('.front-blog-list .title').trunk8({
		lines: 2
	});
} else {
	$('.blog-newentry .title a').trunk8({
		lines: 3
	});
}